import React from "react";

import VersionContainer from "./versionStyles";

const VersionText: React.FC = () => {
  const version = window._env_?.REACT_APP_VERSION_TXT || "not set";

  return <VersionContainer>| Version {version}</VersionContainer>;
};

export default VersionText;